<kt-portlet>
  <!-- PORTLET LOADING | Binded to TABLE Datasource -->
  <kt-portlet-header
    title="{{ 'TABLE.MEETING_LIST' | translate }}"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <button
          (click)="createNewMeeting()"
          mat-raised-button
          matTooltip="New Sales Call"
          color="primary"
          type="button"
          class="mr-2"
        >
          <span class="svg-icon-md" translate>
            <i class="ki ki-calendar-2" style="color: white"></i>
            New Sales Call</span
          >
        </button>
      </div>
      <div>
        <button
          class="mr-2"
          [ngClass]="isMyMeetings ? 'filter-button-active' : ''"
          mat-button
          color="{{ isMyMeetings ? 'primary' : '' }}"
          #myMeetingBtn
          (click)="fetchMyMeetings()"
        >
          My Meetings
        </button>
      </div>
      <div class="btn-group">
        <button
          class="btn btn-sm btn-clean mr-2 dropdown-toggle"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          FILTER
          <i class="ml-2 ki ki-arrow-down text-primary"></i>
        </button>
        <div
          style="z-index: 1000"
          class="dropdown-menu p-5 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg"
          aria-labelledby="dropdownMenuButton"
          (click)="$event.stopPropagation()"
        >
          <div class="row">
            <button class="mr-2" mat-button #clearFiltersBtn (click)="clearFilters()">
              Clear All Filters
            </button>
          </div>
          <mat-label>Date</mat-label>
          <div class="row">
            <mat-form-field appearance="standard" class="col">
              <mat-label>From Date</mat-label>
              <input
                matInput
                [formControl]="startDate"
                [matDatepicker]="startDatePicker"
                ktDateMask
                maxlength="10"
                placeholder="MM/DD/YYYY"
                (dateChange)="setMinDate($event)"
              />
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="standard" class="col">
              <mat-label>To Date</mat-label>
              <input
                matInput
                [formControl]="toDate"
                [matDatepicker]="toDatePicker"
                ktDateMask
                maxlength="10"
                placeholder="MM/DD/YYYY"
                (dateChange)="setMaxDate($event)"
                [min]="startDate.value"
              />
              <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #toDatePicker></mat-datepicker>
            </mat-form-field>
            <a
              (click)="clearDateFilter()"
              class="col-2 text-primary"
              style="display: flex; align-items: center"
              >Clear</a
            >
          </div>
          <kt-general-autocomplete
            [label]="'User'"
            [loadItemsFunction]="userAutocompleteCall"
            [optionFormatter]="stringUtils.displayUserName"
            [valueFormatter]="stringUtils.displayUserName"
            [required]="false"
            [readOnly]="false"
            [control]="searchForm.get('user')"
            [change]="onUsersChange.bind(this)"
            [placeholder]="'Search User'"
            [dataPath]="'data'"
            [appearance]="'standard'"
            #userAutocomplete
          ></kt-general-autocomplete>
          <div>
            <kt-general-autocomplete
              [label]="'Entity'"
              [loadItemsFunction]="entityAutocompleteCall"
              [optionFormatter]="stringUtils.autocompleteEntityFormatter"
              [valueFormatter]="stringUtils.displayName"
              [required]="false"
              [readOnly]="false"
              [control]="searchForm.get('entity')"
              [change]="onEntityChange.bind(this)"
              [placeholder]="'Search Entity'"
              [dataPath]="'data'"
              [appearance]="'standard'"
              #entityAutocomplete
            ></kt-general-autocomplete>
          </div>
          <div>
            <mat-form-field class="mat-form-field-fluid" appearance="standard">
              <mat-label>Status</mat-label>
              <mat-select
                [(value)]="filterStatus"
                (selectionChange)="resetPagination(); loadMeetingsList()"
                placeholder="Status"
              >
                <mat-option value="">{{ 'GLOBAL.ALL' | translate }}</mat-option>
                <mat-option *ngFor="let option of progressOptions" [value]="option">
                  <span
                    class="mr-10 label label-lg label-light-{{
                      option | meetingStatus : 'COLOR'
                    }} label-inline"
                    >{{ option | meetingStatus : 'TEXT' }}
                  </span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </ng-container>
  </kt-portlet-header>
  <!-- end::Header -->

  <!-- start::Body (attribute: ktPortletBody) -->
  <kt-portlet-body>
    <!-- start::FILTERS & GROUP ACTIONS -->
    <div class="form kt-margin-b-30">
      <!-- start::FILTERS -->
      <div class="form-filtration">
        <div class="row align-items-center">
          <div class="col-md-3 kt-margin-bottom-10-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
              <input matInput placeholder="{{ 'TABLE.SEARCH' | translate }}" #searchInput />
              <button
                *ngIf="searchInput.value"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchInput.value = ''; paginator.pageIndex = 0; loadMeetingsList()"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-hint align="start">
                <strong>{{ 'TABLE.SEARCH' | translate }}</strong>
                {{ 'TABLE.IN_ALL_FIELDS' | translate }}
              </mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- end::FILTERS -->
    </div>
    <!-- end::FILTERS & GROUP ACTIONS -->

    <!-- MATERIAL TABLE | Binded to datasources -->
    <!-- See off.documentations 'https://material.angular.io/components/table/overview' -->
    <div class="mat-table-wrapper" style="max-height: calc(100% - 130px)">
      <mat-table
        class="lmat-elevation-z8"
        #table
        [dataSource]="dataSource"
        matSort
        #sort1="matSort"
        matSortActive="created"
        matSortDirection="desc"
        matSortDisableClear
      >
        <!-- Checkbox Column -->

        <ng-container matColumnDef="created">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'MEETING.INPUT.DATE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let meeting">{{ meeting.created | date : 'MM-dd-yy' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="from_time">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'MEETING.INPUT.START_TIME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let meeting">{{
            meeting.from_time + ' UTC' | date : 'MM-dd-yy h:mm a'
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="is_completed">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'MEETING.INPUT.STATUS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let meeting">
            <span
              class="mr-10 label label-lg label-light-{{
                meeting.is_completed | meetingStatus : 'COLOR'
              }} label-inline"
              >{{ meeting.is_completed | meetingStatus : 'TEXT' }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="call_organizer">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'MEETING.INPUT.ORGANIZER' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let meeting">{{
            userObjectNames[meeting.call_organizer]
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="subject">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'MEETING.INPUT.SUBJECT' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let meeting">
            <span style="width: 200px">
              <div class="font-weight-bolder font-size-lg mb-0">{{ meeting.subject }}</div>
              <div *ngIf="meeting.drug" class="font-weight-bold text-muted">
                Drug: {{ meeting.drug.drug }}
              </div>
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="related_to_list">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'MEETING.INPUT.RELATED_ENTITIES' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let meeting">
            <span>
              <span
                class="pr-1 pl-1 text-success text-hover-warning cursor"
                *ngFor="let ent of meeting.related_to_list; let i = index"
                [class.border-right]="i !== meeting.related_to_list.length - 1"
                (click)="navigateEntity(ent.type, ent); $event.stopPropagation()"
                >{{ ent.name }}</span
              >
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="location">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'MEETING.INPUT.LOCATION' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let meeting">{{ meeting.location }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let meeting">
            <ng-template
              [ngxPermissionsOnly]="[
                'canEditSalesCalls',
                'canEditCompletedSalesCalls',
                'canEditOtherResponsiblesSalesCalls'
              ]"
            >
              <button
                color="primary"
                matTooltip="Edit Sales Call"
                (click)="updateSalesCall(meeting, mapUser(meeting.call_organizer))"
                class="btn btn-icon btn-light btn-hover-primary btn-sm margin-2"
              >
                <span class="svg-icon svg-icon-md svg-icon-primary">
                  <span inlineSVG="./assets/media/svg/icons/General/edit_icon.svg"></span>
                </span>
              </button>
            </ng-template>
            &nbsp;
            <button
              color="success"
              matTooltip="{{ 'TABLE.VIEW' | translate }} Sales Call"
              (click)="viewMeeting(meeting)"
              class="btn btn-icon btn-light btn-hover-success btn-sm"
            >
              <span class="svg-icon svg-icon-md svg-icon-success">
                <span inlineSVG="./assets/media/svg/icons/General/visible.svg"></span>
              </span>
            </button>
            &nbsp;
            <button
              color="success"
              matTooltip="Follow-up"
              (click)="openFollowUpDialog(meeting)"
              class="btn btn-icon btn-light btn-hover-primary btn-sm margin-2"
            >
              <i class="flaticon-calendar-with-a-clock-time-tools"></i>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="clickable"
          matTooltip="Edit Sales Call"
          (dblclick)="updateSalesCall(row, mapUser(row.call_organizer))"
        ></mat-row>
      </mat-table>
      <div class="mat-table__message" *ngIf="!dataSource.hasItems">
        {{ 'TABLE.NO_RECORDS' | translate }}
      </div>
      <!-- Message for empty data  -->
      <div class="mat-table__message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'TABLE.PLAESE_WAIT' | translate }}
      </div>
    </div>

    <!-- start: BOTTOM -->
    <div class="mat-table__bottom">
      <!-- MATERIAL SPINNER | Url: 'https://material.angular.io/components/progress-spinner/overview' -->
      <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
      <!-- MATERIAL PAGINATOR | Binded to dasources -->
      <!-- See off.documentations 'https://material.angular.io/components/paginator/overview' -->
      <mat-paginator
        [pageSize]="size"
        (page)="loadPage($event)"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
    <!-- end: BOTTOM -->
  </kt-portlet-body>
  <!-- end::Body -->
</kt-portlet>
